import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * 3NODE — keeps the PDP availability line in sync with the selected variant
 * (Freelo 31610997).
 *
 * product-form.js morphs only a fixed list of elements on variant change and
 * this block is not on it, so without this the line kept showing whatever
 * state the page was first rendered with. Same approach as product-inventory.
 */
class RfAvailability extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  /**
   * Replaces the label + value with the freshly rendered ones.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateAvailability = (event) => {
    // Colour swatches can swap to a different product (combined listing); size
    // changes stay on the same one. Ignore events fired for a product we are
    // not showing, otherwise a swatch would repaint the wrong line.
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const updated = event.detail.data.html.querySelector('rf-availability');

    if (!updated) return;

    morph(this, updated, { childrenOnly: true });

    // A variant update means a size has been picked, so the line describes
    // that size from now on, not the model summary (Freelo 32850809). The
    // server can't tell: Horizon re-renders with ?option_values=, not
    // ?variant=, so the fresh markup may still default to the summary.
    const summary = this.querySelector('[data-rf-avail-summary]');
    const line = this.querySelector('[data-rf-avail-variant]');
    if (summary) summary.hidden = true;
    if (line) line.hidden = false;
  };
}

if (!customElements.get('rf-availability')) {
  customElements.define('rf-availability', RfAvailability);
}
